import {Component, OnInit} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import moment from 'moment';
import {ConsultingService, LoaderService} from '@app/shared/services';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';

@Component({
  selector: 'app-medicine-unit',
  templateUrl: './medicine-unit.component.html',
  styleUrls: ['./medicine-unit.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    PageHeaderComponent
  ]
})
export class MedicineUnitComponent implements OnInit {
  public now = new Date();
  public date: any;
  public user_rights: any = {};
  public unit_id = "";
  public index = 0;
  fileName: any;
  start = 0;
  limit = 10;
  p = 50;
  public collection: any = '';
  page = 1;
  public user_data: any = {};
  public unit_data: any =
    {
      unit_id: '',
      unit_name: '',
      short_name: ''
    }
  status: any;
  data: any;

  constructor(private loaderService: LoaderService, public consultingService: ConsultingService, private toastr: ToastrService,) {

  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.getUnitList();
    this.unit_data.user_id = this.user_data.user_id;
    this.formatDateTime();
  }

  public saveUnit() {
    if (this.unit_data.unit_name == "") {
      this.toastr.error('Please enter unit !');
    }
    if (this.unit_data.short_name == "") {
      this.toastr.error('Please enter short form !');
    } else {
      const postData = {
        user_id: this.user_data.user_id,
        unit_id: this.unit_id,
        unit_name: this.unit_data.unit_name,
        short_name: this.unit_data.short_name

      }
      this.loaderService.display(true);
      this.consultingService.saveUnit(postData).subscribe((result: any) => {
        window.scrollTo(0, 0)
        if (result["status"] == "Success") {
          this.loaderService.display(false);
          this.toastr.success(result.msg);
          this.getUnitList();
          this.clearUnit();
          this.index = result.data_id;
        } else {
          this.toastr.error( result.msg);
          this.loaderService.display(false);
        }
      })
    }
  }

  public clearUnit() {
    this.unit_data = {
      unit_name: '',
      short_name: ''
    }
  }

  public editUnit(data: any) {
    this.unit_data.unit_name = data.UNIT_DESC;
    this.unit_id = data.UNIT_ID;
    this.unit_data.short_name = data.SHORT_FORM;
    window.scrollTo(0, 0);
  }

  public getUnitList(page = 0) {
    const limit = 50;
    this.start = page * limit;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      unit_id: '0'
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.consultingService.listUnit(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.data = result['data'];
        this.collection = result['total_count'];
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
        this.collection = 0;
      }
    });
  }

  public formatDateTime() {
    if (this.now) {
      this.date = moment(this.now, 'yyyy-MM-D HH:mm.ss a').format('D-MM-Y h:mm a');
    }
  }

  public clear_search() {
    if (this.unit_data.search_medicine != '') {
      this.clearUnit();
      this.getUnitList();
    }
  }
}

